import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useProduct, useSystemActions } from 'stores';
import styled from 'styled-components';

const OwnerContent = styled.div`
	border-left: 3px solid #26305f;
	margin-left: 25vw;
	padding-top: 20vw;
	height: -webkit-fill-available;
`;

const OwnerItem = styled.div`
	position: relative;
	padding-left: 32px;
	padding-right: 9vw;
	margin-bottom: 3vh;

	::before {
		content: '';
		display: block;
		box-sizing: border-box;
		width: 13px;
		height: 13px;
		border: 2px solid #26305f;
		border-radius: 12px;
		background: #fff;
		position: absolute;
		left: -8px;
		top: 22px;
	}
`;

const OwnerSinceLeft = styled.p`
	display: block;
	width: 17vw;
	position: absolute;
	left: -22vw;
	text-align: center;
	line-height: 150%;
	font-size: 3vw;
`;

const OwnerItemContentBox = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: flex-start;
`;

const OwnerDetail = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: center;
	padding-bottom: 3vw;
`;

const OwnerNameBox = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-content: center;
	justify-content: center;
	align-items: flex-start;
	padding-left: 4vw;
`;

const OwnerInfoTitle = styled.span`
	font-size: 75%;
`;

const OwnerName = styled.span`
	color: #2e5881;
	font-size: 125%;
	word-break: break-all;
	word-wrap: break-word;
	margin-top: -7%;
`;

const OwnerSince = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	padding-left: 7vw;
	padding-bottom: 3vw;
	margin-top: -5%;
`;

const OwnerInfoContent = styled.span`
	word-break: break-word;
	word-break: break-all;
`;

const OwnershipTimeline = () => {
	const { getImage } = useSystemActions();
	const product = useProduct();
	const { t } = useTranslation();

	const ownerHistory = product ? product.ownerHistory : null;
	console.log('ownerHistory -> ' + ownerHistory);

	if (ownerHistory === null || ownerHistory.length === 0) {
		return (
			<>
				<Typography>
					There is no ownerHistory data, please check ....
				</Typography>
			</>
		);
	}

	return (
		<>
			<div>
				<OwnerContent>
					{ownerHistory.map((obj: any, index: number) => (
						<OwnerItem key={index}>
							<OwnerSinceLeft>
								{obj['effectiveAtOnlyDate']}
							</OwnerSinceLeft>
							<OwnerItemContentBox>
								<OwnerDetail>
									<Box
										sx={{
											width: '15vw',
											borderRadius: '7.5vw',
										}}
										component="img"
										alt="default_owner_profile"
										src={
											obj['avatarImagePath']
												? `${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_IMAGE}?name=${obj['avatarImagePath']}`
												: getImage('portrait_icon.png')
										}
									/>
									<OwnerNameBox>
										<OwnerInfoTitle>
											{index === 0
												? t('ownershipTimeline.current')
												: t(
														'ownershipTimeline.previous'
												  )}
										</OwnerInfoTitle>
										<OwnerName>
											{obj['displayName']}
										</OwnerName>
									</OwnerNameBox>
								</OwnerDetail>
								<OwnerSince>
									<OwnerInfoTitle>
										{t('ownershipTimeline.since')}
									</OwnerInfoTitle>
									<OwnerInfoContent>
										{obj['effectiveAtDateTime']}
									</OwnerInfoContent>
								</OwnerSince>
							</OwnerItemContentBox>
						</OwnerItem>
					))}
				</OwnerContent>
			</div>
		</>
	);
};

export default OwnershipTimeline;
